import type { TextStyleValue } from '@elfsight/configurator-contracts';

export const paragraphDefaultTextStyle: TextStyleValue = {
  fontSize: 15,
  lineHeight: '20px',
  fontWeight: 'normal'
};
